import React from 'react';
import {PageHeader, Card, Col, Row, Space, Anchor} from "antd";

const { Link } = Anchor;

const Libraries = () => {
    return (
        <>
            <div className="site-card-wrapper">
                <PageHeader
                    className="site-page-header"
                    title="Библиотеки"
                />
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="React" bordered={false}>
                            <Anchor>
                                <Link href='https://reactjs.org/' title='https://reactjs.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Redux" bordered={false}>
                            <Anchor>
                                <Link href='https://redux.js.org/' title='https://redux.js.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="React-redux" bordered={false}>
                            <Anchor>
                                <Link href='https://react-redux.js.org/' title='https://react-redux.js.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="Redux-saga" bordered={false}>
                            <Anchor>
                                <Link href='https://redux-saga.js.org/' title='https://redux-saga.js.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="redux-persist" bordered={false}>
                            <Anchor>
                                <Link href='https://github.com/rt2zz/redux-persist#readme' title='https://github.com/rt2zz/redux-persist'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Ant Design" bordered={false}>
                            <Anchor>
                                <Link href='https://ant.design/' title='https://ant.design/'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="Typescript" bordered={false}>
                            <Anchor>
                                <Link href='https://www.typescriptlang.org/' title='https://www.typescriptlang.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="eslint" bordered={false}>
                            <Anchor>
                                <Link href='https://eslint.org/' title='https://eslint.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="prettier" bordered={false}>
                            <Anchor>
                                <Link href='https://prettier.io/' title='https://prettier.io/'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="Webpack" bordered={false}>
                            <Anchor>
                                <Link href='https://webpack.js.org/' title='https://webpack.js.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="axios" bordered={false}>
                            <Anchor>
                                <Link href='https://github.com/axios/axios' title='https://github.com/axios/axios'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="google-maps-react" bordered={false}>
                            <Anchor>
                                <Link href='https://www.npmjs.com/package/google-maps-react' title='https://www.npmjs.com/package/google-maps-react'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="Moment" bordered={false}>
                            <Anchor>
                                <Link href='https://momentjs.com/' title='https://momentjs.com/'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="react-color" bordered={false}>
                            <Anchor>
                                <Link href='https://github.com/casesandberg/react-color' title='https://github.com/casesandberg/react-color'/>
                            </Anchor>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Less" bordered={false}>
                            <Anchor>
                                <Link href='http://lesscss.org/' title='http://lesscss.org/'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="react-css-theme-switcher" bordered={false}>
                            <Anchor>
                                <Link href='https://github.com/JoseRFelix/react-css-theme-switcher#readme' title='https://github.com/JoseRFelix/react-css-theme-switcher'/>
                            </Anchor>
                        </Card>
                    </Col>
                </Row>
                <br/>
            </div>
        </>
    );
};

export default Libraries;